export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const LOAD_CATEGORY = "LOAD_CATEGORY";
export const UPDATE_MAIN_IMAGE = "UPDATE_MAIN_IMAGE";
export const ADD_DETAIL_IMAGE = "ADD_DETAIL_IMAGE";
export const DELETE_DETAIL_IMAGE = "DELETE_DETAIL_IMAGE";
export const EDIT_DESCRIPTIONS = "EDIT_DESCRIPTIONS";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const SAVE_PRODUCT = "SAVE_PRODUCT";